<template>
  <div>
    <Head title="{{modelNameLowerCase}} Create"/>
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-gray-400 hover:text-gray-600" :href="`/applicants/${data.applicant_id}/view`">
        {{ data.applicant_name }}
      </Link>
      <span class="text-gray-400 font-medium">/ </span>
      <Link class="text-gray-400 hover:text-gray-600" :href="`/applicants/${data.applicant_id}/treatments/${data.treatment_id}/view`">{{data.treatment_type_name}}</Link>
      <span class="text-gray-400 font-medium">/ </span>
      {{ $t('treatmentlogements.new') }}
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <Form :form-data="form" is-new="true" :status_actuals="status_actuals" :types="types"></Form>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">{{ $t('global.create') }}
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import Form from './Form'

export default {
  components: {
    Form,
    Head,
    Link,
    LoadingButton,
  },
  layout: Layout,
  remember: 'form',
  props: {
    data: Object,
    status_actuals: Array,
    types: Array
  },
  data() {
    return {
      form: this.$inertia.form({
        id: '',
        treatment_id: '',
        status: '',
        status_actual: '',
        type: '',
        date_start: '',
        date_end: '',
        created_at: '',
        updated_at: '',
        notes: '',
      }),
    }
  },
  methods: {
    store() {
      this.form.post(`/applicants/${this.data.applicant_id}/treatments/${this.data.treatment_id}/treatment-logements/create`)
    },
  },
}
</script>
